import React from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import UnifiedTaskDetails from './UnifiedTaskDetails';
import View_edit_taskdetails from '../modalPopup/View_edit_taskdetails';
import '../assets/css/card-task-dialog.css';

/**
 * New Taskboard card dialog: two top-level tabs until unified UI replaces the editor.
 */
const CardTaskDialogContent = ({ cardId, boardId, onClose, onReviewAction }) => {
    if (!cardId) return null;

    return (
        <TabView className="card-task-dialog-tabs">
            <TabPanel header="Overview">
                <UnifiedTaskDetails
                    cardId={cardId}
                    onReviewAction={onReviewAction}
                />
            </TabPanel>
            <TabPanel header="Edit card">
                <View_edit_taskdetails
                    taskId={cardId}
                    boardId={boardId}
                    onClose={onClose}
                />
            </TabPanel>
        </TabView>
    );
};

export default CardTaskDialogContent;
